import { Link } from 'react-router'
import type { CatalogCard } from '@/types/card'
import { useApp, useCardUpdate } from '@/store/app'
import { Highlighted, OfflineMark, OrgBadge, OrgStripe, UpdateMark } from './primitives'

/**
 * Listeneintrag für Suche und Katalog.
 *
 * Eine Zeile, die man im Gehen trifft: volle Breite, 56 px hoch, der Titel zuerst.
 * Der Trefferausschnitt darunter erklärt, warum die Karte gefunden wurde — ohne ihn
 * wirken Treffer aus dem Fließtext willkürlich.
 */
export function CardRow({
  card,
  snippet,
  highlights,
}: {
  card: CatalogCard
  snippet?: string | null
  highlights?: readonly (readonly [number, number])[]
}) {
  const state = useApp((s) => s.offlineStates.get(card.id)) ?? 'fehlt'
  const update = useCardUpdate(card.id)

  return (
    <Link
      to={`/karte/${card.id}`}
      className="tap relative flex flex-col justify-center gap-1 border-b border-line
                 bg-surface py-3 pl-4 pr-3 transition-colors duration-100
                 hover:bg-raised focus-visible:bg-raised"
    >
      <OrgStripe organization={card.organization} />

      <div className="flex items-start justify-between gap-3">
        <span className="text-base font-semibold leading-tight text-ink-strong">
          {card.title}
        </span>
        <OfflineMark state={state} />
      </div>

      {card.subtitle && <span className="text-sm leading-snug text-muted">{card.subtitle}</span>}

      {snippet && (
        <span className="mt-0.5 line-clamp-2 text-sm leading-snug text-muted">
          <Highlighted text={snippet} ranges={highlights ?? []} />
        </span>
      )}

      <div className="mt-0.5 flex items-center gap-2">
        <OrgBadge organization={card.organization} />
        {update && <UpdateMark kind={update} />}
      </div>
    </Link>
  )
}
